<div class="secondary-nav-container">
  <div class="container">
    <ul class="navpane">
      <li
        [ngClass]="{
          active: isLinkActive(secondaryNavItem.url),
          hide: secondaryNavItem.isHidden
        }"
        *ngFor="let secondaryNavItem of secondaryNav; index as SNavIndex"
      >
        <a
          *ngIf="
            secondaryNavItem.isRouter === 'true' && !secondaryNavItem.isHidden
          "
          [attr.aria-current]="isLinkActive(secondaryNavItem.url) ? 'page' : ''"
          [attr.data-qa]="'gn-secondary-nav-' + SNavIndex"
          [routerLink]="secondaryNavItem.url"
          id="{{ secondaryNavItem.id }}"
          >{{ secondaryNavItem.title }}</a
        >
        <a
          *ngIf="
            secondaryNavItem.isRouter === 'false' && !secondaryNavItem.isHidden
          "
          [attr.aria-current]="isLinkActive(secondaryNavItem.url) ? 'page' : ''"
          [attr.data-qa]="'gn-secondary-nav-' + SNavIndex"
          [href]="secondaryNavItem.url"
          id="{{ secondaryNavItem.id }}"
          >{{ secondaryNavItem.title }}</a
        >
      </li>
    </ul>
  </div>
</div>
